import { render, staticRenderFns } from "./PaymentMethodsList.vue?vue&type=template&id=88040dae"
import script from "./PaymentMethodsList.vue?vue&type=script&lang=js"
export * from "./PaymentMethodsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports